import React, { useState } from 'react';
import TextArea from 'components/shared/debouncedTextArea';
import TryAgain from 'components/TryAgain';
import { Button } from 'ui';
import { TEXT_VARIANTS } from 'ui/Typography';
import request from 'utils/request_ajax';
import { routes } from 'constants/config';
import FeedbackSubmissionSuccess from './FeedbackSubmissionSuccess';

const RevealFeedbackForm = ({
  recipient,
  betaFeatureName,
  updateHiddenState,
}) => {
  const [updatedFeedback, setUpdatedFeedback] = useState('');
  const [feedbackSubmissionSuccess, setFeedbackSubmissionSuccess] =
    useState(false);
  const [feedbackSubmissionFailed, setFeedbackSubmissionFailed] =
    useState(false);

  const handleFeedback = async () => {
    try {
      await request
        .postJSON(routes.BETA_FEEDBACK, {
          recipient,
          feature_name: betaFeatureName,
          feedback: updatedFeedback,
        })
        .then(res => {
          if (res.success) {
            updateHiddenState(true);
            setFeedbackSubmissionSuccess(true);
            setFeedbackSubmissionFailed(false);
            setUpdatedFeedback('');
          } else {
            setFeedbackSubmissionFailed(true);
          }
        });
    } catch (error) {
      setFeedbackSubmissionFailed(true);
    }
  };

  return (
    <div>
      {feedbackSubmissionSuccess ? (
        <FeedbackSubmissionSuccess inline />
      ) : (
        <div className="pt-12">
          <TextArea
            variant={TEXT_VARIANTS.BODY}
            placeholder={t('beta_feedback.placeholder')}
            className="Modal-input"
            onChange={value => setUpdatedFeedback(value)}
            autoFocus
          />
          {feedbackSubmissionFailed ? (
            <TryAgain
              disabled={!updatedFeedback.trim()}
              handleRetry={handleFeedback}
            />
          ) : (
            <div className="d-f jc-e mt-12">
              <Button
                type="button"
                customColor
                onClick={handleFeedback}
                disabled={!updatedFeedback.trim()}
              >
                {t('lesson_overview.submit_button')}
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default RevealFeedbackForm;
